import { Component, OnInit, Input } from '@angular/core';
import icmore_vert from '@iconify/icons-ic/twotone-more-vert';
import data from '@iconify/icons-fa-solid/filter';
import { HistoryService } from 'src/@evo/services/history.service';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/pages/Services/shared.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'nc-breadcrumbs-quick-menu',
  templateUrl: './breadcrumbs-quick-menu.component.html',
  styleUrls: ['./breadcrumbs-quick-menu.component.scss']
})
export class BreadcrumbsQuickMenuComponent implements OnInit {

  @Input() isMenuDisplay = false;
  @Input() data: any = {};
  menuObjectKeys = [];
  icmore_vert = icmore_vert;
  historyData: any[] = [];
  providerId;
  providerType;
  countryId;

  constructor(private historyService: HistoryService, private router: Router,
    public translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.buildQuickMenu(this.data);
  }
 
  buildQuickMenu(data):void {
    this.menuObjectKeys = Object.keys(data);
    this.historyService.updateHistory();
    this.historyService.getHistory().subscribe((res: any) => {
      this.historyData = res;
      if (res.length > 1 && res.length !== 1) {
        this.historyData = this.historyData.reverse();
        // this.historyData = this.historyData.reverse();
        this.historyData = [...new Map(this.historyData.map(item => [item['url'], item])).values()];
        const path = this.router.url.split('/');
        const actualPath = path[path.length - 1].split('?');
        this.historyData = this.historyData.filter((ele) => ele.text !== actualPath[0]);
        if(this.router.url=="/layout/newhealthcareprovider" || this.router.url.split('?')[0] =="/layout/contractedparties" || this.router.url.split('?')[0] =="/layout/agreements" || this.router.url=="/layout/schedule"){
          this.isMenuDisplay=false;
        }
      }
    });
  }
  goToComponentNavigation(item): void {
    const params = item.params;
    this.router.navigate([item.url], {
      queryParams: params,
    });
  }

  ngOnDestroy(): void {
    // this.historyData = [];
    // this.historyService.clearHistory();
  }

}
